import { word } from "@modules/core/utils/i18n"
import { MediaItemDraftDtoSchema } from "@modules/sessionBlock/media/mediaDto"
import { getMediaValidationSchema, MediaItemFormikType } from "@modules/sessionBlock/media/mediaFormikTypes"
import * as Yup from "yup"
import { z } from "zod"

export type CommentFormikType = {
  note?: string
  medias: MediaItemFormikType[]
  noteAndMediaIsVisible: boolean
}

export const getCommentValidationSchema = () => {
  return Yup.object().shape({
    note: Yup.string().required(word("global.form.required")),
    noteAndMediaIsVisible: Yup.boolean(),
    medias: Yup.array()
      .of(getMediaValidationSchema())
      .test("", word("sessionForm.blocks.add_media.wrong_quantity_of_media"), (value) => {
        return (value && value.length <= 5) || !value
      }),
  })
}

export const CommentInputDtoSchema = z.object({
  note: z.string().nullish(),
  noteAndMediaIsVisible: z.boolean(),
  medias: z.array(MediaItemDraftDtoSchema),
})

export type CommentInputDto = z.infer<typeof CommentInputDtoSchema>
